import axios from "axios";
import { getStoredToken } from "./user-storage";
// import store from './StoreProvider/configureStore';
import { setUserData } from "./store/slices/user";
import store from "./store/configureStore";
import { useNavigate } from "react-router-dom";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  // baseURL: process.env.BACKEND_URL,
  // timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    // "accept-language": localStorage.getItem("currentLang") || "ar",
    withCredentials: true,
  },
});
// store.subscribe(() => {
//   console.log(store.getState().user.data)
// })
axiosInstance.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + getStoredToken();
  config.headers["accept-language"] = localStorage.getItem("currentLang") || "ar";
  return config;
});

axiosInstance.interceptors.response.use(null, (err) => {
  console.log("interceptors err:", err);
  // const navigate = useNavigate();
  console.log("aaaaaaaaaaaaaaaaaaaa", err?.response?.status)

  const statusCode = err?.response?.status;
  if (statusCode === 401) {
    console.log("aaaaaaaaaaaaaaaaaaaa")
    localStorage.clear();
    // navigate("/login");
    store.dispatch(setUserData(null));
  }
  return err;
});
